import React, { useState, useEffect } from 'react';
import config from "../../Config";
import axios from "axios";

function StudentGroupDropDown(props) {


    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [Groups, setGroups] = useState([]);

    useEffect(() => {

        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            SchoolID: 1,
            pageNo: 1,
            pageSize: 1000,
        };

        var api_config = {
            method: 'post',
            url: config.base_url + 'Student/GetStudentGroups',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        //console.log(data);

        axios(api_config)
            .then(function (response) {
                ////console.log(response.data);
                setGroups(response.data.ListofRecords || []);
            })
            .catch(function (error) {
                //console.log(error);
            });

    }, []);

    if (Groups.length > 0) {
        return (

            Groups.map((item, index) => {
                return (
                    <option value={item.Group_ID} key={index} selected={item.Group_ID == 1 ? true : false}>{item.Group_Name}</option>
                )
            })
        );
    }
}

export default StudentGroupDropDown;